module.exports = __webpack_public_path__ + "img/maintain.184f044d.svg";